import React from 'react';
import * as S from './RequestsList.styled';
import { useSelector } from 'react-redux';
import Table from './components/Table';
import { RequestsListItemsSelector } from './RequestsListSlice';

const RequestsList: React.FC = () => {
  // Список логов
  const requests = useSelector(RequestsListItemsSelector);

  return (
    <S.Wrap>
      <Table items={requests} />
    </S.Wrap>
  );
};

export default RequestsList;
